// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbSiteStructure__separator":"mc_a pz_fa"};